export default __webpack_public_path__ + "static/media/postkarte.bb871ce8.glb";